import { Reveal } from "@/components/site/Motion";
import { ContactButton } from "@/components/site/ContactButton";
import { LinkButton } from "@/components/site/LinkButton";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { CoachingScope } from "@/components/site/CoachingScope";

export const AboutInvitation = () => (
  <section className="px-5 py-20 sm:px-8 md:py-28 lg:px-12" data-testid="about-closing">
    <Reveal className="mx-auto grid max-w-6xl items-center gap-10 rounded-[2rem] border border-[#d7bd8d]/60 bg-[#fffaf3] p-7 sm:p-12 md:grid-cols-[1.3fr_0.7fr] lg:gap-16 lg:p-16">
      <div>
        <p className="eyebrow text-center sm:text-left">Connect with Sheetal</p>
        <h2 className="font-display mt-5 text-center text-[2.5rem] font-medium leading-[1.08] tracking-tight text-[#221e1b] sm:text-left sm:text-[3.5rem]">
          Let’s talk about<br />
          <em className="text-[#7a5615]">your journey.</em>
        </h2>
        <p className="mt-6 max-w-md text-[1.0625rem] leading-[1.75] text-[#5d544c] sm:text-lg">
          Curious about Panchmaya or Sheetal’s approach? Get in touch to ask your questions
          and explore whether the journey feels right for you.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-5 sm:justify-start">
          <WhatsAppButton testId="about-closing-whatsapp-btn">Inquire About 1:1 Coaching</WhatsAppButton>
          <ContactButton testId="about-closing-contact-btn" size="large" variant="outline" />
          <LinkButton to="/journey" variant="text" testId="about-closing-journey-btn">
            Explore the Journey
          </LinkButton>
        </div>
        <CoachingScope />
      </div>
      <div className="flex items-center justify-center gap-4 border-t border-[#e4dacb] pt-7 sm:justify-start md:flex-col md:border-l md:border-t-0 md:pl-8 md:pt-0 md:text-center lg:pl-12">
        <img
          src="/sheetal-garg-320.webp"
          alt=""
          loading="lazy"
          decoding="async"
          width="144"
          height="144"
          className="h-20 w-20 shrink-0 rounded-full border border-[#e4dacb] object-cover object-[60%_20%] md:h-36 md:w-36"
        />
        <div>
          <p className="font-display text-3xl font-medium text-[#221e1b]">Sheetal Garg</p>
          <p className="mt-1 text-base leading-relaxed text-[#5d544c]">Founder and Lifestyle Coach<br />Panchmaya</p>
        </div>
      </div>
    </Reveal>
  </section>
);
